var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66655 7.83332C8.53988 7.83332 8.41321 7.78665 8.31321 7.68665C8.11988 7.49332 8.11988 7.17332 8.31321 6.97998L13.7799 1.51332C13.9732 1.31998 14.2932 1.31998 14.4865 1.51332C14.6799 1.70665 14.6799 2.02665 14.4865 2.21998L9.01988 7.68665C8.91988 7.78665 8.79321 7.83332 8.66655 7.83332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 5.03334C14.3932 5.03334 14.1666 4.80668 14.1666 4.53334V1.83334H11.4666C11.1932 1.83334 10.9666 1.60668 10.9666 1.33334C10.9666 1.06001 11.1932 0.833344 11.4666 0.833344H14.6666C14.9399 0.833344 15.1666 1.06001 15.1666 1.33334V4.53334C15.1666 4.80668 14.9399 5.03334 14.6666 5.03334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 15.1667H5.99992C2.37992 15.1667 0.833252 13.62 0.833252 10V6.00001C0.833252 2.38001 2.37992 0.833344 5.99992 0.833344H7.33325C7.60659 0.833344 7.83325 1.06001 7.83325 1.33334C7.83325 1.60668 7.60659 1.83334 7.33325 1.83334H5.99992C2.92659 1.83334 1.83325 2.92668 1.83325 6.00001V10C1.83325 13.0733 2.92659 14.1667 5.99992 14.1667H9.99992C13.0733 14.1667 14.1666 13.0733 14.1666 10V8.66668C14.1666 8.39334 14.3933 8.16668 14.6666 8.16668C14.9399 8.16668 15.1666 8.39334 15.1666 8.66668V10C15.1666 13.62 13.6199 15.1667 9.99992 15.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.da197934312d3d84310c27d1ac08fcb0.svg";
export { ForwardRef as ReactComponent };